import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  ElementRef,
  ViewChildren,
  QueryList,
  HostListener,
  Input,
  Optional,
  Inject,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DashboardService } from "./dashboard.service";
import { ApiList } from "./api";
import {
  API_SERVICE_TOKEN,
  PBF_TOKEN,
  ROLE_SERVICE_TOKEN,
} from "../service/InjectionToken";
import { DashboardPorletsService } from "./dashboardPorlets.service";
import { Subscription } from "rxjs";
import CircularJSON from "circular-json";

import { MAT_DATE_FORMATS } from "@angular/material/core";
import { cloneDeep, find } from "lodash";
import { DashboardLayoutComponent } from "@syncfusion/ej2-angular-layouts";
import { FieldFormatComponent } from "./sidebar-iconlist/field-format/field-format.component";
import { GadgetTableComponent } from "./gadget-group/gadget-table/gadget-table.component";
import { GadgetPivotComponent } from "./gadget-group/gadget-pivot/gadget-pivot.component";
import { GadgetPivotChartComponent } from "./gadget-group/gadget-pivot-chart/gadget-pivot.component";
import { GadgetTransposeComponent } from "./gadget-group/gadget-transpose/gadget-transpose.component";
import { getTranslation } from "../utils/utils";
import {
  // PdfExportProperties,
  ExcelExportProperties,
  ColumnModel,
} from "@syncfusion/ej2-angular-grids";
import { IAxisSet } from "@syncfusion/ej2-angular-pivotview";
import { HttpClient } from "@angular/common/http";
import { DataMartNewComponent } from "./dashboard-properties/data-mart-new/data-mart-new.component";
import { BarChartsComponent } from "./bar-charts/bar-charts.component";
import { debounce } from "./bar-charts/utils";
import { DatePipe } from "@angular/common";
import { PaneDownloadComponent } from "./dialog-group/download/index.component";
import { filter } from "rxjs/operators";
import { DialogService } from "../service/dialog.service";

let dateFormat = "DD-MM-YYYY";
if (localStorage["setting"]) {
  const dateArray = find(
    JSON.parse(localStorage.getItem("setting") || "{}"),
    (item) => item && item["parameter"] === "DATE_FORMAT"
  );
  if (dateArray) {
    dateFormat = dateArray.value;
  }
}

const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: dateFormat,
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

@Component({
  selector: "rs-dashboard",
  templateUrl: "./pane-group-new.component.html",
  styleUrls: ["./pane-group-new.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class PaneGroupNewComponent implements OnInit {
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;
  @Input() appCode = "PMS";
  @ViewChild("sidebar", { static: false }) sidebar: any;
  @ViewChildren("unclick") unclick: QueryList<ElementRef>;
  @ViewChildren("unclickGrand") unclickGrand: QueryList<ElementRef>;
  @ViewChildren("newChart") newChart: QueryList<BarChartsComponent>;
  portlet;
  tabactive: boolean;
  dashboard;
  selectedY = [];
  selectedSecondY = [];
  selectedX = [];
  selectedMultiples: any;
  selectTheme: any;
  hasInit = true;
  activeTabId: any;
  hasChangeDataTable = false;
  activeTabLabel = "";
  stayActiveTab: boolean;
  @HostListener("document:click", ["$event"]) bodyClick(e) {
    if (
      this.unclick &&
      this.unclick.first &&
      e.target.tagName !== "IMG" &&
      !this.unclick.first.nativeElement.contains(e.target)
    ) {
      this.showSubTotalGroup = false;
    }

    if (
      this.unclickGrand.first &&
      e.target.tagName !== "IMG" &&
      !this.unclickGrand.first.nativeElement.contains(e.target)
    ) {
      this.showgrandTotalGroup = false;
      this.showTableGrandTotalGroup = false;
    }
  }
  public translation = getTranslation()
  private lang;
  push_btn = false;
  @ViewChild("defaultLayout", { static: false })
  dashboardLayout: DashboardLayoutComponent;
  @ViewChild("canvas", { static: true }) canvas: ElementRef;
  private config;
  public draggableHandle: string = ".gadget-title";
  private subscriptions: Subscription[] = [];
  public url;
  public url_id;
  public url_type;
  // private img;
  public datePipeFormat;
  public haveFullScreen = [];
  // private clientHeight_;
  public cellSpacing: number[] = [20, 20];
  public cellAspectRatio;
  public resizableHandles;
  newPosition = [];

  public mediaQuery;
  figureCode;
  customized = false;
  public chartTypeList = ["Column", "Bar", "Line", "Area", "Scatter", "Polar"];
  @ViewChildren("table")
  public table: QueryList<GadgetTableComponent>;
  @ViewChildren("pivot")
  public pivot: QueryList<GadgetPivotComponent | GadgetPivotChartComponent>;
  @ViewChildren("transpose")
  public transpose: QueryList<GadgetTransposeComponent>;
  public pivotTableSubTotalList: Array<any> = [
    {
      selected: false,
      value: this.translation.SHOW_SUB_TOTALS || "Show sub totals",
    },
    {
      selected: false,
      value: this.translation.HIDE_SUB_TOTALS || "Hide sub totals",
    },
    {
      selected: false,
      value:
        this.translation.SHOW_SUB_TOTALS_ROWS_ONLY ||
        "Show sub totals rows only",
    },
    {
      selected: false,
      value:
        this.translation.SHOW_SUB_TOTALS_COLUMNS_ONLY ||
        "Show sub totals columns only",
    },
  ];
  public pivotTableGrandTotalList: Array<any> = [
    {
      selected: false,
      value: this.translation.SHOW_GRAND_TOTALS || "Show grand totals",
    },
    {
      selected: false,
      value: this.translation.HIDE_GRAND_TOTALS || "Hide grand totals",
    },
    {
      selected: false,
      value:
        this.translation.SHOW_GRAND_TOTALS_ROWS_ONLY ||
        "Show grand totals rows only",
    },
    {
      selected: false,
      value:
        this.translation.SHOW_GRAND_TOTALS_COLUMNS_ONLY ||
        "Show grand totals columns only",
    },
  ];
  public tableGrandTotalList: Array<any> = [
    {
      selected: false,
      value: this.translation.SHOW_GRAND_TOTALS || "Show grand totals",
    },
    {
      selected: false,
      value: this.translation.HIDE_GRAND_TOTALS || "Hide grand totals",
    },
  ];

  themeData: any = [
    {
      id: "theme13",
      value: ["#1C3484", "#35B9FC"],
    },
    {
      id: "theme14",
      value: ["#04578F", "#3EBBCE"],
    },
    {
      id: "theme15",
      value: ["#1C3484", "#136BBB", "#35B9FC"],
    },
    {
      id: "theme16",
      value: ["#04578F", "#0082AF", "#3EBBCE"],
    },
    {
      id: "theme17",
      value: ["#1C3484", "#1659A9", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme18",
      value: ["#04578F", "#0070A3", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme19",
      value: ["#1C3484", "#1659A9", "#1375C4", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme20",
      value: ["#04578F", "#0070A3", "#0089B4", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme21",
      value: ["#1C3484", "#1659A9", "#1368B8", "#1375C4", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme22",
      value: ["#04578F", "#0070A3", "#007FAD", "#0089B4", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme23",
      value: [
        "#1C3484",
        "#1659A9",
        "#145FAF",
        "#1368B8",
        "#1375C4",
        "#1D97E1",
        "#35B9FC",
      ],
    },
    {
      id: "theme24",
      value: [
        "#04578F",
        "#0070A3",
        "#0078A9",
        "#007FAD",
        "#0089B4",
        "#16A2C2",
        "#3EBBCE",
      ],
    },
    {
      id: "theme11",
      value: [
        "#1C3484",
        "#194697",
        "#1659A9",
        "#136BBB",
        "#147ECC",
        "#1B92DD",
        "#26A5ED",
        "#35B9FC",
      ],
    },
    {
      id: "theme12",
      value: [
        "#04578F",
        "#00659B",
        "#0073A6",
        "#0082AF",
        "#0090B8",
        "#0F9EC0",
        "#29ADC7",
        "#3EBBCE",
      ],
    },
    {
      id: "theme1",
      value: [
        "#594bb9",
        "#f1af32",
        "#4688ed",
        "#e0563e",
        "#803a63",
        "#6dd8b5",
        "#e87225",
        "#c5df42",
        "#c6437d",
      ],
    },
    {
      id: "theme2",
      value: [
        "#4688ed",
        "#f1af32",
        "#e0563e",
        "#803a63",
        "#6dd8b5",
        "#e87225",
        "#c5df42",
        "#c6437d",
        "#594bb9",
      ],
    },
    {
      id: "theme3",
      value: [
        "#c6437d",
        "#c5df42",
        "#e87225",
        "#6dd8b5",
        "#e0563e",
        "#803a63",
        "#f1af32",
        "#594bb9",
        "#4688ed",
      ],
    },
    {
      id: "theme4",
      value: [
        "#2f499f",
        "#8d1d2e",
        "#e9bf35",
        "#51772f",
        "#469bd8",
        "#5c448f",
        "#da732f",
        "#245353",
        "#43a245",
      ],
    },
    {
      id: "theme5",
      value: [
        "#383839",
        "#446ec6",
        "#cf6384",
        "#ebb37e",
        "#71a249",
        "#4bb1a5",
        "#e87225",
        "#c5df42",
        "#c6437d",
      ],
    },
    {
      id: "theme6",
      value: [
        "#517ae1",
        "#6386e5",
        "#7491e9",
        "#849dec",
        "#94a9ef",
        "#a4b6f2",
        "#b4c3f6",
        "#c4cff9",
        "#d4ddfd",
      ],
    },
    {
      id: "theme7",
      value: [
        "#39828e",
        "#488e99",
        "#579aa5",
        "#66a6b0",
        "#75b3bd",
        "#85bfc9",
        "#95cdd6",
        "#a4dae2",
        "#b5e8f0",
      ],
    },
    {
      id: "theme8",
      value: [
        "#e7963d",
        "#ea9e4b",
        "#eea659",
        "#f0ae68",
        "#f2b678",
        "#f3bf87",
        "#f5c798",
        "#f6d0aa",
        "#f7d9bb",
      ],
    },
    {
      id: "theme9",
      value: [
        "#64a8b4",
        "#7ebec0",
        "#9cc9ca",
        "#b8d4d4",
        "#d9d6cd",
        "#d8b7a7",
        "#ce8f93",
        "#c1627f",
        "#ad2458",
      ],
    },
    {
      id: "theme10",
      value: [
        "#4176ba",
        "#559ae8",
        "#70b3e8",
        "#a7cce7",
        "#dfdfdf",
        "#d2a08b",
        "#c76a50",
        "#ca4e34",
        "#aa3c29",
      ],
    },
  ];
  startEdit = false;
  public showSubTotalGroup: boolean = false;
  public showgrandTotalGroup: boolean = false;
  public showTableGrandTotalGroup: boolean = false;
  public Current_PortletId;
  public restoreModel: any = [];
  public themeObj = {};
  enableMultipleAxis = false;
  showLegend = false;
  timer;
  tabList;
  activeTab = 1;
  prevId = null;
  dashboard_sidebar = false;
  ActiveDashboardPortlets = [];
  portlets = [];
  hasResize = false;

  @ViewChild("panesList", { static: true }) panesList: ElementRef;
  constructor(
    public dialog: MatDialog,
    private dialogService: DialogService,
    public dashboardService: DashboardService,
    private api: ApiList,
    private activatedRoute: ActivatedRoute,
    public DashboardPorletsService: DashboardPorletsService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    @Optional() @Inject(PBF_TOKEN) private pbf: any,
    @Optional() @Inject(API_SERVICE_TOKEN) private http: any,
    @Optional() @Inject(ROLE_SERVICE_TOKEN) public rs: any
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        if (
          this.hasResize &&
          e.url === this.activatedRoute["_routerState"].snapshot.url
        ) {
          if (this.dashboardLayout) {
            this.ActiveDashboardPortlets = [];
            this.hasResize = false;
            this.pbf.pageLoading = true;
            this.pbf.pageLoading_.next(true);
            this.dashboardLayout.removeAll();
            this.ref.markForCheck();
            setTimeout(() => {
              this.setActiveDashboardPortlets();
            }, 500);
          }
        }
      });
  }

  ngOnInit() {
    this.pbf.pageLoading = true;
    this.pbf.pageLoading_.next(true);
    this.ref.markForCheck();
    this.ref.detectChanges();

    if (this.themeData && this.themeData.length > 0) {
      this.themeData.forEach((e) => {
        this.themeObj[e.id] = e["value"];
      });
    }
    this.getInfo();
    this.getDashboard();

    this.subscriptions.push(
      this.pbf.pub$.subscribe((res) => {
        if (
          res.refreshUrl &&
          res.refreshUrl === this.activatedRoute["_routerState"].snapshot.url
        ) {
          this.pbf.pageLoading = true;
          this.pbf.pageLoading_.next(true);
          setTimeout(() => {
            this.getDashboard();
          }, 500);
        }
      })
    );

    this.subscriptions.push(
      this.dashboardService.getDashboardRename().subscribe((res) => {
        if (this.dashboard && this.dashboard.id === res.id) {
          this.dashboard.dashboardGroupName = res.dashboardGroupName;
          this.dashboard.dashboardGroupId = res.dashboardGroupId;
          this.dashboard.description = res.description;
          this.dashboard.name = res.name;
          this.updateDashboardLastUpdateDate();
        }
      })
    );

    this.subscriptions.push(
      this.dashboardService.getCustomizeStatus().subscribe((id) => {
        if (this.dashboard && this.dashboard.id === id) {
          this.ref.markForCheck();
          this.ref.detectChanges();
        }
      })
    );

    this.subscriptions.push(
      this.pbf.getHasResize().subscribe((url) => {
        if (url) {
          if (this.activatedRoute["_routerState"].snapshot.url === url) {
            if (this.dashboardLayout) {
              this.ActiveDashboardPortlets = [];
              this.dashboardLayout.removeAll();
              this.pbf.pageLoading = true;
              this.pbf.pageLoading_.next(true);
              this.ref.markForCheck();
              setTimeout(() => {
                this.setActiveDashboardPortlets();
              }, 500);
            }
          } else {
            this.hasResize = true;
          }
        }
      })
    );
  }

  private getAllFields(item, noDetect = false): Promise<any[]> {
    if (!noDetect) {
      this.pbf.pageLoading = true;
    }
    return new Promise((resolve, reject) => {
      const dataMartCode = item.figureCode;
      const dataObj = {
        language: this.lang,
        dataMartCode,
      };
      this.DashboardPorletsService.setSchemaParams(
        dataObj,
        dataMartCode,
        this.dashboard
      );
      this.http.post(this.api.urlList.GetSchema, dataObj, (res) => {
        if (!noDetect) {
          this.pbf.pageLoading = false;
          this.pbf.pageLoading_.next(true);
        }
        resolve(res);
      });
    });
  }

  onCloseRight(e) {
    this.push_btn = false;
    this.ref.detectChanges();
  }

  setActiveDashboardPortlets(noDetect = false) {
    if (this.hasChangeDataTable) {
      this.ActiveDashboardPortlets = [];
      this.ref.markForCheck();
    }
    const portlets =
      this.portlets.filter((portlet) => {
        if (!portlet || !portlet.config) {
          return;
        }
        const config = JSON.parse(portlet.config);
        const tabId = config.tabId || 1;
        if (tabId === this.activeTab) {
          return portlet;
        }
      }) || [];
    setTimeout(() => {
      this.ActiveDashboardPortlets = [...portlets];
      if (
        !this.ActiveDashboardPortlets.length &&
        this.dashboardLayout &&
        this.dashboardLayout.panels &&
        this.dashboardLayout.panels.length
      ) {
        this.dashboardLayout.removeAll();
      }
      this.hasChangeDataTable = false;
      if (!noDetect) {
        this.pbf.pageLoading = false;
        this.pbf.pageLoading_.next(true);
      }
      this.ref.detectChanges();
    });
  }

  onActiveTab(tab, index) {
    this.dashboard_sidebar = false;
    this.push_btn = false;
    const { id, label } = tab;
    if (tab.id === this.activeTab) {
      return;
    }
    this.activeTabId = id;
    this.activeTabLabel = label;
    if (index !== 0) {
      this.prevId = this.tabList[index - 1].id;
    }
    this.startEdit = false;
    this.activeTab = id;
    this.setActiveDashboardPortlets();
  }

  onDeleteTab(item) {
    let _title =
      this.translation.ARE_YOU_SURE_TO_DELETE_DASHBOARD_TAB_WARNING_MESSAGE ||
      ".ARE_YOU_SURE_TO_DELETE_DASHBOARD_TAB_WARNING_MESSAGE";
    _title = _title.replace("{Tab Name}", item.label);
    const dialogRef = this.dialogService.showCommonDilaog({
      title: this.translation.DELETE_RECORD || ".DELETE_RECORD",
      description: _title,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res === "save") {
        const isActive = this.activeTab === item.id;
        let index = 0;
        for (let i = this.portlets.length - 1; i >= 0; i--) {
          const config = JSON.parse(this.portlets[i].config);
          if (config.tabId === this.activeTab) {
            this.portlets.splice(i, 1);
          }
        }
        this.tabList.forEach((tab, i) => {
          if (tab.id === item.id) {
            this.tabList.splice(i, 1);
            index = i;
            this.ref.markForCheck();
            this.ref.detectChanges();
          }
        });
        if (isActive) {
          if (!this.tabList[index]) {
            index -= 1;
          }
          this.activeTab = this.tabList[index].id;
          this.activeTabId = this.activeTab;
          this.portlets.forEach((portlet) => {
            const config = JSON.parse(portlet.config);
            config.activeTab = this.activeTab;
            portlet.config = CircularJSON.stringify(config);
          });
          this.ref.detectChanges();
          this.onActiveTab(this.tabList[index], index);
        }
        this.savedashboard("true");
      }
    });
  }

  onAddTab() {
    const label = `Tab ${this.tabList.length + 1}`;
    this.prevId = this.tabList[this.tabList.length - 1].id;
    let newId = 1;
    this.tabList.forEach((tab) => {
      newId = Math.max(newId, tab.id);
    });
    this.activeTab = newId + 1;
    this.tabList.push({
      id: this.activeTab,
      label,
      displayLabel: `${this.translation.TAB || "Tab"} ${
        this.tabList.length + 1
      }`,
    });
    this.activeTabId = this.activeTab;
    this.activeTabLabel = label;
    // 隐藏右侧菜单，清除当前选中的portlet
    this.portlet = null;
    this.dashboard_sidebar = false;
    this.hasChangeDataTable = true;
    this.push_btn = false;
    this.setActiveDashboardPortlets();
  }

  setTabInput(e) {
    this.portlets.forEach((portlet) => {
      const _config = JSON.parse(portlet.config);
      const _tabId = _config.tabId || 1;
      if (_tabId === this.activeTab) {
        _config.tabLabel = e.target.value;
        portlet.config = CircularJSON.stringify(_config);
      }
    });
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  saveTabInput(item) {
    this.startEdit = false;
    item.displayLabel = this.truncateText(item.label);
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  onStartEdit(id) {
    if (!this.customized) {
      return;
    }
    if (this.activeTab !== id) {
      return;
    }
    this.startEdit = true;
  }

  private initTabList(noDetect = false) {
    this.tabList = [];
    if (!this.activeTab || !this.stayActiveTab) {
      this.activeTab = 1;
    }
    this.prevId = null;
    const tabMap = {};
    this.portlets.forEach((portlet, idx) => {
      if (portlet.config) {
        const config = JSON.parse(portlet.config);
        const txt = this.translation["TAB"] || "Tab";
        if (config.activeTab && !this.stayActiveTab) {
          this.activeTab = config.activeTab;
        }
        const tabId = config.tabId || 1;
        const tabLabel = config.tabLabel || "Tab 1";
        let displayLabel = config.tabLabel || `${txt} 1`;
        if (config.tabLabel && config.tabLabel.startsWith("Tab")) {
          displayLabel = txt + config.tabLabel.slice(3);
        }
        if (!tabMap[tabId]) {
          this.tabList.push({
            id: tabId,
            label: tabLabel,
            displayLabel: tabLabel
              ? this.truncateText(displayLabel)
              : `${this.translation.TAB || "Tab"} 1`,
          });
          tabMap[tabId] = true;
        }

        // if (!this.activeTabId) {
        // 	this.activeTab = tabId;
        // 	this.activeTabId = tabId;
        // 	this.activeTabLabel = tabLabel;
        // }
      }
    });

    if (!this.tabList.length) {
      this.tabList = [
        {
          id: 1,
          label: "Tab 1",
          displayLabel: `${this.translation.TAB || "Tab"} 1`,
        },
      ];
      this.activeTabId = 1;
      this.activeTabLabel = "Tab 1";
    }

    this.tabList = this.tabList.sort((a, b) => a.id - b.id);
    const activeTab =
      this.tabList.find((i) => i.id === this.activeTab) || this.tabList[0];
    if (activeTab.id) {
      this.activeTabId = activeTab.id;
      this.activeTabLabel = activeTab.label;
    }
    this.stayActiveTab = false;
    this.setPrevId();
    if (!noDetect) {
      this.setActiveDashboardPortlets();
    }
  }

  async initlayout(shouldGetFields = false, noDetect = false) {
    if (!shouldGetFields) {
      this.initTabList(noDetect);
    }
    if (this.portlets && this.portlets.length > 0) {
      for (let portlet of this.portlets) {
        const config: any = JSON.parse(portlet.config);
        if (shouldGetFields) {
          // GetSchema配置的列数据源
          const fields: any[] = await this.getAllFields(portlet);
          // 每个portlet自定义的数据
          config.fields.forEach((field) => {
            if (field.format) {
              fields.forEach((_f) => {
                if (_f.colName === field.colName) {
                  _f.format = field.format;
                }
              });
            }
            const item = fields.find((_f) => _f.colName === field.colName);
            if (!item) {
              fields.push(field);
            }
          });
          if (config.portletType === "pivot") {
            // @ts-ignore
            config.fields = fields;
            portlet.config = CircularJSON.stringify(config);
          }
        }
        portlet.newId = "portlet_" + this.pbf.Guid();
        portlet.col = portlet.posX;
        portlet.row = portlet.posY;
        portlet.sizeX = portlet.width;
        portlet.sizeY = portlet.height;
      }

      this.initCharData(noDetect);
      this.setActiveDashboardPortlets(noDetect);
    } else {
      this.ActiveDashboardPortlets = [];
      this.dashboardLayout.removeAll();
    }
  }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.pbf.getTriggerDashboardFilterChange().subscribe((e) => {
        const dashboarId = e["id"];
        const newId = e["newId"];
        if (dashboarId !== this.dashboard.id) {
          return;
        }
        this.filterData(newId);
      })
    );

    this.subscriptions.push(
      this.dashboardService
        .getchangelayout()
        .subscribe(({ status, id = "" }) => {
          if (this.dashboard && this.dashboard.id === id) {
            const params = status === "true" ? false : true;
            this.initlayout(params);
          }
        })
    );

    this.subscriptions.push(
      this.dashboardService.editProperties().subscribe(({ status, id }) => {
        if (!this.dashboard || this.dashboard.id !== id || this.timer) {
          return;
        }
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 200);
        this.dialog.closeAll();
        this.dialog
          .open(DataMartNewComponent, {
            data: {
              edit: status,
              dashboardId: this.url_id,
              dashboard: this.dashboard,
            },
            height: "85%",
            width: "55%",
            disableClose: true,
            panelClass: "report-dialog",
          })
          .afterClosed()
          .subscribe((e) => {
            if (!e) {
              return;
            }
            const { push_btn, portlet, dashboard } = e;
            this.dashboard = cloneDeep(dashboard);
            this.portlet = cloneDeep(portlet);
            this.push_btn = push_btn;
            this.dashboardService.updateDatamartEntity.next(this.dashboard);
            this.ref.markForCheck();
            this.ref.detectChanges();
          });
      })
    );

    this.subscriptions.push(
      this.dashboardService.getDownloadDashbord().subscribe((id) => {
        if (this.dashboard && this.dashboard.id === id) {
          // this.downloadAll();
          for (let item of this.ActiveDashboardPortlets) {
            this.download(item);
          }
        }
      })
    );
    this.subscriptions.push(
      this.dashboardService.getaddportlet().subscribe((id) => {
        if (this.dashboard && this.dashboard.id === id) {
          if (this.portlet) {
            this.portlets.push(this.portlet);
          }

          let config: any =
            this.portlet.config instanceof String
              ? JSON.parse(this.portlet.config)
              : this.portlet.config;
          if (typeof config === "string") {
            config = JSON.parse(config);
          }

          const portletType =
            config.portletType === "historicalIRR"
              ? config.selectedVisualType
              : config.portletType;

          // 只有新增的Porlet是图表类才需要初始化
          if (
            this.portlet &&
            this.portlet.config &&
            ["newcolumn", "newline", "newcolumnline"].includes(portletType)
          ) {
            this.initCharData(); // 拼接Chart需要用的数据源
          }
          this.getNewPosition();
          this.setActiveDashboardPortlets();
        }
      })
    );
    this.subscriptions.push(
      this.dashboardService.getLeftMenuBar().subscribe((open) => {
        let width = this.panesList.nativeElement.offsetWidth;
        if (open) {
          this.panesList.nativeElement.style.width = width - 195 + "px";
        } else {
          this.panesList.nativeElement.style.width = width + 195 + "px";
        }
      })
    );
  }

  @debounce(100)
  private filterData(id) {
    this.chartUpdate(id);
  }

  chartUpdate(id?: string) {
    this.hasChangeDataTable = true;
    if (id) {
      this.dashboardService.chartUpdate.next(id);
    }
    this.initCharData(); // 拼接Chart需要用的数据源
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  private getInfo() {
    this.translation = getTranslation();
    this.lang = this.pbf.getLanguageParams();
    this.datePipeFormat = localStorage.getItem("datePipe");
  }

  public getPorletConfig(portlet) {
    if (!portlet.config) {
      return;
    }
    const config = JSON.parse(portlet.config);
    if (!config.pvtableChartSetting) {
      return;
    }
    this.showLegend =
      !!config.pvtableChartSetting.chartSettings.legendSettings.visible;
    this.enableMultipleAxis =
      config.pvtableChartSetting.chartSettings.enableMultipleAxis;
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  updateTheme(e) {
    const {
      selectedX,
      selectedY,
      selectedSecondY,
      selectedMultiples,
      selectTheme,
    } = e;
    this.selectedX = selectedX;
    this.selectedY = selectedY;
    this.selectedSecondY = selectedSecondY;
    this.selectedMultiples = selectedMultiples;
    this.selectTheme = selectTheme;
  }

  updateDashboard(e) {
    const { portlets, dashboard, noDetect, stayActiveTab } = e;
    this.stayActiveTab = stayActiveTab;
    this.dashboard = cloneDeep(dashboard);
    this.portlets = [...portlets];
    if (!noDetect) {
      this.ref.markForCheck();
    }
    setTimeout(() => {
      this.dashboardService.updateDatamartEntity.next(dashboard);
    });
  }

  updatePorletConfig(e) {
    const { newId, config } = e;
    const _config = Object.assign({}, config);
    this.portlet.config = CircularJSON.stringify(_config);
    this.portlets.forEach((portlet, i) => {
      if (portlet.newId === newId) {
        this.portlets[i].config = CircularJSON.stringify(_config);
      }
    });
    this.portlets = [...this.portlets];
    this.setActiveDashboardPortlets();
  }

  public edit(item) {
    const config = JSON.parse(item.config);
    const portletType =
      config.portletType === "historicalIRR"
        ? config.selectedVisualType
        : config.portletType;
    if (["newcolumn", "newline", "newcolumnline"].includes(portletType)) {
      this.selectedY = config["selectedY"];
      this.selectedSecondY = config.selectedSecondY;
      this.selectedX = config["selectedX"];
      this.selectedMultiples = config["selectedMultiples"];
      this.selectTheme = config["selectTheme"];
    }
    this.portlet = cloneDeep(item);
    if (this.push_btn) {
      this.sidebar.portlet = this.portlet;
    }
    this.dashboard_sidebar = true;
    this.push_btn = true;
    this.figureCode = item.figureCode;
    this.tabactive = false;
    this.ref.detectChanges();
    this.dashboardService.portletEdit.next(this.url_id);
  }

  @debounce(300)
  GetgadgetTitle(config) {
    if (config && config !== "null") {
      let config_ = JSON.parse(config);
      return config_.gadgetTitle;
    } else {
      return "";
    }
  }

  public getPortletType(item) {
    const config = item && item.config ? JSON.parse(item.config) : {};
    if (config.portletType) {
      if (config.portletType === "historicalIRR") {
        return config.selectedVisualType;
      }
      return config.portletType;
    }
  }

  public delete(item) {
    const index = this.portlets.findIndex((x) => x.newId === item.newId);
    this.dashboardLayout.removePanel(item.newId);
    this.portlets.splice(index, 1);
    this.setActiveDashboardPortlets();
    this.getNewPosition();
  }

  public copyPortlet(item) {
    const portlet = { ...item };
    portlet.id = "00000000-0000-0000-0000-000000000000";
    portlet.newId = "portlet_" + this.pbf.Guid();
    // 处理 1.复制别的复制体  2.新建的个体 3.已存在的个体
    portlet.copyId = portlet.copyId
      ? portlet.copyId
      : item.id === "00000000-0000-0000-0000-000000000000"
      ? item.newId
      : item.id;
    this.DashboardPorletsService.portletData_New[this.dashboard.id][
      portlet.newId
    ] = cloneDeep(
      this.DashboardPorletsService.portletData_New[this.dashboard.id][
        portlet.copyId
      ]
    );
    this.portlets.push(portlet);
    this.setActiveDashboardPortlets();
    this.getNewPosition();
  }

  public getAsofdate(item) {
    return JSON.parse(item.config).asOfDate;
  }
  public getCurrency(config) {
    return JSON.parse(config).currencyCode;
  }
  public getFigurecode(figureCode) {
    switch (figureCode) {
      case "Tasks":
        return 1;
      case "FundList":
        return 2;
      case "IRR":
        return 3;
      case "Notes":
        return 4;
      default:
        return 0;
    }
  }
  public getTableName(item) {
    let config = item.config ? JSON.parse(item.config) : {};
    if (config.portletType) {
      let typeList = ["table", "financialTable", "transpose", "pivot"];
      let idx = typeList.indexOf(config.portletType);
      return idx > -1 ? true : false;
    }
  }

  public pushSlider() {
    this.push_btn = !this.push_btn;
  }

  private getFigureCode(figureCode) {
    let codeArr = ["Tasks", "FundList", "IRR", "Notes"];
    let i = codeArr.indexOf(figureCode);
    return i > -1 ? true : false;
  }
  x;
  y;

  public getDashboard() {
    this.url = "dashboardDetail";
    let url_arr = this.pbf.getRouterUrl().split("?");
    this.url_id = this.pbf.getUrlId(url_arr[0]);
    this.url_type =
      url_arr[1] == "dashboardType=customizedBeta"
        ? "customizedBeta"
        : url_arr[1] == "dashboardType=sharedBeta"
        ? "sharedBeta"
        : "";
    this.DashboardPorletsService.GetDashboardV1(
      this.url_id,
      true,
      (res, portlets = []) => {
        this.hasInit = true;
        if (!res) {
          this.pbf.pageLoading = false;
          this.pbf.pageLoading_.next(true);
          return;
        }
        this.portlets = [...portlets];
        this.initlayout(false, true);
        setTimeout(() => {
          this.dashboardService.updateDatamartEntity.next(this.dashboard);
          // this.chartUpdate();
          this.pbf.pageLoading = false;
          this.pbf.pageLoading_.next(true);
        }, 500);
      },
      false,
      (res) => {
        this.dashboard = Object.assign({}, res);
        if (this.dashboardLayout) {
          this.dashboardLayout.refresh();
        }
        this.ref.markForCheck();
        this.ref.detectChanges();
      }
    );
  }
  public routerPage() {
    this.router.navigateByUrl("/pages/dashboard/dashboardlist");
  }

  public displayIconPrompt(item) {
    return JSON.parse(item.config).portletType ||
      this.getFigureCode(item.figureCode)
      ? false
      : true;
  }
  public async configurations(item, event) {
    const portletType = this.getPortletType(item);
    switch (portletType) {
      case "table":
        const table = find(
          (this.table as any)._results,
          (el) => el.portlet.newId === item.newId
        );
        if (
          table.grid &&
          table.grid.getCurrentViewRecords() &&
          table.grid.getCurrentViewRecords().length
        ) {
          // let mask: any = document.querySelector("#pivot-table-mask");
          // if (mask) mask.style.display = "block";
          let _y = 0;
          if (event && event.target) {
            const { y } = event.target.getBoundingClientRect();
            if (document.body.clientHeight - y < 400) {
              _y = -415;
            }
          }
          table.grid &&
            table.grid.columnChooserModule &&
            table.grid.columnChooserModule.openColumnChooser(200, _y);
        }
        break;
      case "newchart":
      case "pivot":
        const pivot = find(
          (this.pivot as any)._results,
          (el) => el.portlet.newId === item.newId
        );
        if (
          pivot.fieldlistObj.dialogRenderer &&
          pivot.fieldlistObj.dialogRenderer.fieldListDialog
        ) {
          pivot.fieldlistObj.dialogRenderer.fieldListDialog.show();
        }
        break;
      case "transpose":
        const transpose = find(
          (this.transpose as any)._results,
          (el) => el.portlet.newId === item.newId
        );
        // 开启适配 手动缩小
        transpose.grid.columnChooserModule.showCustomColumnChooser();
        setTimeout(() => {
          let dlg: any = document.querySelector(
            ".e-rescolumnchooserdiv.e-responsive-dialog"
          );
          if (dlg) {
            dlg.style.opacity = 1;
            dlg.style.setProperty("width", "300px", "important");
            dlg.style.setProperty("height", "350px", "important");
            dlg.style.setProperty("position", "absolute", "important");
            dlg.style.setProperty(
              "left",
              event.clientX - 135 + "px",
              "important"
            );
            dlg.style.setProperty(
              "top",
              event.clientY + 30 + "px",
              "important"
            );
          }
        }, 0);
        break;
    }
  }

  private setPrevId() {
    this.tabList.forEach((tab, i) => {
      if (tab.id === this.activeTab) {
        if (this.tabList[i - 1]) {
          this.prevId = this.tabList[i - 1].id;
        }
      }
    });
  }

  drop(e) {
    const { previousIndex, currentIndex } = e;
    const prevId = this.tabList[previousIndex].id;
    const currId = this.tabList[currentIndex].id;

    for (let i = this.tabList.length - 1; i >= 0; i--) {
      const tabId = this.tabList[i].id;
      if (tabId === prevId) {
        this.tabList[i].id = currId;
      }
      if (tabId === currId) {
        this.tabList[i].id = prevId;
      }
    }
    for (let i = this.portlets.length - 1; i >= 0; i--) {
      const config = JSON.parse(this.portlets[i].config);
      const tabId = config.tabId;
      if (tabId === prevId) {
        config.tabId = currId;
        this.portlets[i].config = JSON.stringify(config);
      }
      if (tabId === currId) {
        config.tabId = prevId;
        this.portlets[i].config = JSON.stringify(config);
      }
    }
    if (this.activeTab === currId) {
      this.activeTab = prevId;
    } else if (this.activeTab === prevId) {
      this.activeTab = currId;
    }
    this.setPrevId();
    [this.tabList[previousIndex], this.tabList[currentIndex]] = [
      this.tabList[currentIndex],
      this.tabList[previousIndex],
    ];
    this.tabList = [...this.tabList];

    this.ref.markForCheck();
  }
  closeAll() {
    this.pbf.pageLoading = true;
    this.pbf.pageLoading_.next(true);
    this.ref.markForCheck();
    let hasConfig = false;
    this.ActiveDashboardPortlets.forEach((portlet) => {
      const portletType = this.getPortletType(portlet);
      switch (portletType) {
        case "pivot":
        case "newchart":
          const dom = document.getElementById(
            `${portlet.newId}_DeferUpdateButton2`
          );
          if (dom) {
            hasConfig = true;
            dom.click();
          }
          break;
        case "table":
          const cancelBtn = document.querySelector(".e-cc-cnbtn");
          if (cancelBtn) {
            hasConfig = true;
            // @ts-ignore
            cancelBtn.click();
          }
          break;
      }
    });
    if (hasConfig) {
      setTimeout(() => {
        this.pbf.pageLoading = false;
        this.pbf.pageLoading_.next(true);
        this.ref.markForCheck();
      }, 400);
    } else {
      this.pbf.pageLoading = false;
      this.pbf.pageLoading_.next(true);
    }
    return hasConfig;
  }

  public downloadAll() {
    const dialogRef = this.dialog.open(PaneDownloadComponent, {
      data: {
        portlets: this.portlets,
        dashboard: this.dashboard,
      },
      height: "850px",
      width: "562px",
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  public download(item) {
    const portletType = this.getPortletType(item);
    const title = this.GetgadgetTitle(item.config);
    switch (portletType) {
      case "table":
        this.downloadTable(item, title);
        break;
      case "newchart":
      case "pivot":
        const pivot = find(
          (this.pivot as any)._results,
          (el) => el.portlet.newId === item.newId
        );
        pivot.headRowSpan = 0; //重置导出header处理
        pivot.headRowCount = 0; //重置导出header处理
        const excelExportProperties_pivot: ExcelExportProperties = {
          fileName: title
            ? title + ".xlsx"
            : "Pivot-" + new Date().toISOString() + ".xlsx",
        };
        if (pivot.pivotObj.dataSourceSettings.formatSettings) {
          pivot.pivotObj.dataSourceSettings.formatSettings.forEach(
            (setting) => {
              // syncfusion format transform to excel format
              const map = {
                "#,###,,.0;(#,###,,.0)": '0.0,,"";(0.0,,)',
                '0.0,,"";(0.0,,)': "#,###,,.0;(#,###,,.0)",
                "#,###,,;(#,###,,)": '0,,"";(0,,)',
                '0,,"";(0,,)': "#,###,,;(#,###,,)",
                "#,###,,.00;(#,###,,.00)": '0.00,,"";(0.00,,)',
                '0.00,,"";(0.00,,)': "#,###,,.00;(#,###,,.00)",
              };

              if (map[setting.format]) {
                setting.format = map[setting.format];
                setTimeout(() => {
                  setting.format = map[setting.format];
                  this.ref.markForCheck();
                  this.ref.detectChanges();
                });
              }
            }
          );
        }
        this.updateFormat(
          pivot.pivotObj.grid.columns as ColumnModel[],
          pivot.pivotObj
        );
        pivot.pivotObj.excelExport(excelExportProperties_pivot);
        break;
      // case "transpose":
      // 	// const transpose = find(
      // 	// 	(this.transpose as any)._results,
      // 	// 	(el) => el.portlet.newId === item.newId
      // 	// );
      // 	break;
      case "newcolumn":
      case "newline":
      case "newcolumnline":
        const chartIdx = this.getChartIndexInAll(item);
        const selectedComponent = this.newChart.toArray()[chartIdx];
        selectedComponent.exportChart();
        break;
    }
  }

  // 根据idx获取点击图表在图表列表里的真正顺序
  getChartIndexInAll(item) {
    const charArr = this.ActiveDashboardPortlets.filter((e) => {
      return ["newcolumn", "newline", "newcolumnline"].includes(
        JSON.parse(e.config).portletType
      );
    });
    let resultIdx = 0;
    if (charArr.length > 0) {
      charArr.forEach((e, idx) => {
        if (e.newId == item.newId) {
          resultIdx = idx;
        }
      });
    }
    return resultIdx;
  }

  public downloadTable(item, title) {
    // Table 下载全部数据
    let config = JSON.parse(item.config);
    let pageSetting = Object.assign(
      {
        currentPage: 1,
        pageSize: 9999999,
      },
      config && config.tableSortSetting
    );
    let params = this.DashboardPorletsService.getParamsByPortlet(
      item,
      pageSetting,
      null,
      this.dashboard
    );
    // json buffer
    this.httpClient
      .post(this.api.baseurl + this.api.urlList.GetPortletDataV2, params)
      .subscribe(
        (result) => {
          if (result) {
            const table = find(
              (this.table as any)._results,
              (el) => el.portlet.newId === item.newId
            );
            const excelExportProperties: ExcelExportProperties = {
              fileName: title
                ? title + ".xlsx"
                : "Table-" + new Date().toISOString() + ".xlsx",
              // @ts-ignore
              dataSource: result.data,
            };
            if (table) {
              table.grid.excelExport(excelExportProperties);
            }
          }
        },
        (response) => {},
        () => {}
      );
  }

  private updateFormat(columns: ColumnModel[], pivotObj) {
    var fList = pivotObj.renderModule.getFormatList();
    for (var i = 0; i < columns.length; i++) {
      if (
        (columns[i] as ColumnModel).columns &&
        (columns[i] as ColumnModel).columns.length > 0
      ) {
        this.updateFormat(
          (columns[i] as ColumnModel).columns as ColumnModel[],
          pivotObj
        );
      } else {
        if (
          columns[i].customAttributes &&
          fList[(columns[i].customAttributes.cell as IAxisSet).actualText] ===
            "N"
        ) {
          (columns[i] as ColumnModel).format = undefined;
        }
      }
    }
  }

  public fieldFormat(item) {
    this.portlet = cloneDeep(item);
    const dialogRef = this.dialog.open(FieldFormatComponent, {
      data: {
        portletData: item,
        portlets: this.portlets,
      },
      height: "850px",
      minWidth: "562px",
      autoFocus: false,
      disableClose: true,
      panelClass: "dialog-position",
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  public openFilter(item) {
    this.portlet = cloneDeep(item);
    this.dashboard_sidebar = true;
    this.push_btn = true;
    this.figureCode = item.figureCode;
    this.tabactive = true;
    this.dashboardService.portletEdit.next(this.url_id);
  }

  updatePushBtn(e: boolean) {
    this.push_btn = e;
    this.ref.markForCheck();
  }

  toggleCustomize(customized) {
    this.customized = customized;
    this.ref.markForCheck();
  }

  toggleSidebar(bool) {
    this.dashboard_sidebar = bool;
    this.ref.markForCheck();
  }

  onToggleTabactive(bool) {
    this.tabactive = bool;
    this.ref.markForCheck();
  }

  updatePorlet(portlet) {
    if (!portlet) {
      this.portlet = null;
      return;
    }
    this.portlet = cloneDeep(portlet);
    this.portlets.forEach((_portlet, i) => {
      if (_portlet.newId === portlet.newId) {
        this.portlets[i] = Object.assign({}, portlet);
      }
    });
    this.portlets = [...this.portlets];
  }

  public addPorlet() {
    this.push_btn = true;
    this.dashboard_sidebar = true;
    this.portlet = null;
    this.tabactive = false;
    this.dashboardService.create_btn.next(this.url_id);
  }

  public closeSidebar(e) {
    this.dashboard_sidebar = false;
    this.ref.markForCheck();
  }

  resizeStop(args) {
    this.getNewPosition();
    if (args.element.querySelector(".e-grid")) {
      const table = find(
        (this.table as any)._results,
        (el) => el.portlet.newId === args.element.id
      );
      if (table) {
        table.grid.height = parseInt(args.element.style.height) - 80;
        table.grid.refreshColumns();
      }
    }

    if (args.element.querySelector(".e-pivotview")) {
      const pivot = find(
        (this.pivot as any)._results,
        (el) => el.portlet.newId === args.element.id
      );
      if (pivot) {
        pivot.pivotObj.layoutRefresh();
      }
    }
  }

  dragStop(e) {
    this.getNewPosition();
  }

  getNewPosition() {
    const pdata = this.dashboardLayout.serialize();
    this.newPosition = [...pdata];
    this.portlets.forEach((portlet) => {
      pdata.forEach((p) => {
        if (portlet.newId === p.id) {
          portlet = {
            ...portlet,
            posX: p.col,
            posY: p.row,
            col: p.col,
            row: p.row,
            width: p.sizeX,
            height: p.sizeY,
            sizeX: p.sizeX,
            sizeY: p.sizeY,
          };
        }
      });
    });
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  openSubtotal(item) {
    this.Current_PortletId = item.newId;
    this.config = item.config ? JSON.parse(item.config) : {};
    this.pivotTableSubTotalList.map((el) => {
      el.selected = false;
    });
    this.getSelectTotalGroupStatus("sub");
    this.showSubTotalGroup = !this.showSubTotalGroup;
    this.showgrandTotalGroup = false;
  }

  openGrandtotal(item) {
    this.Current_PortletId = item.newId;
    this.config = item.config ? JSON.parse(item.config) : {};
    this.pivotTableGrandTotalList.map((el) => {
      el.selected = false;
    });
    if (this.getPortletType(item) === "table") {
      this.getSelectTotalGroupStatus("tableGrand");
      this.showTableGrandTotalGroup = !this.showTableGrandTotalGroup;
    } else {
      this.getSelectTotalGroupStatus();
      this.showgrandTotalGroup = !this.showgrandTotalGroup;
      this.showSubTotalGroup = false;
    }
  }

  selectTotalGroup(index, type, item) {
    if (this.getPortletType(item) === "pivot") {
      const pivot = find(
        (this.pivot as any)._results,
        (el) => el.portlet.newId === item.newId
      );
      if (type === "sub") {
        this.showSubTotalGroup = false;
        this.pivotTableSubTotalList.forEach((subtotal) => {
          subtotal.selected = false;
        });
        this.pivotTableSubTotalList[index].selected = true;
        if (pivot.pivotObj) {
          switch (index) {
            case 0:
              this.config.fields.map((el) => {
                el.showSubTotals = true;
              });
              pivot.pivotObj.dataSourceSettings.showSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnSubTotals = true;
              this.config.showSubTotals = true;
              this.config.showRowSubTotals = true;
              this.config.showColumnSubTotals = true;
              break;
            case 1:
              this.config.fields.map((el) => {
                el.showSubTotals = false;
              });
              pivot.pivotObj.dataSourceSettings.showSubTotals = false;
              pivot.pivotObj.dataSourceSettings.showRowSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnSubTotals = true;
              this.config.showSubTotals = false;
              this.config.showRowSubTotals = true;
              this.config.showColumnSubTotals = true;
              break;
            case 2:
              this.config.fields.map((el) => {
                el.showSubTotals = false;
              });
              for (let gitem of this.config.xaxis.groups) {
                const field = this.config.fields.filter(
                  (fl) => fl.colName === gitem.name
                );
                if (field.length > 0) {
                  field[0].showSubTotals = true;
                }
              }
              pivot.pivotObj.dataSourceSettings.showSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnSubTotals = false;
              this.config.showSubTotals = true;
              this.config.showRowSubTotals = true;
              this.config.showColumnSubTotals = false;
              break;
            case 3:
              this.config.fields.map((el) => {
                el.showSubTotals = false;
              });
              for (let item of this.config.columnGroup) {
                const field = this.config.fields.filter(
                  (fl) => fl.colName === item.name
                );
                if (field.length > 0) {
                  field[0].showSubTotals = true;
                }
              }
              pivot.pivotObj.dataSourceSettings.showSubTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowSubTotals = false;
              pivot.pivotObj.dataSourceSettings.showColumnSubTotals = true;
              this.config.showSubTotals = true;
              this.config.showRowSubTotals = false;
              this.config.showColumnSubTotals = true;
              break;
            default:
              break;
          }
        }
      } else {
        this.showgrandTotalGroup = false;
        this.pivotTableGrandTotalList.forEach((grandtotal) => {
          grandtotal.selected = false;
        });
        this.pivotTableGrandTotalList[index].selected = true;
        if (pivot.pivotObj) {
          switch (index) {
            case 0:
              pivot.pivotObj.dataSourceSettings.showGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnGrandTotals = true;
              this.config.showGrandTotals = true;
              this.config.showRowGrandTotals = true;
              this.config.showColumnGrandTotals = true;
              break;
            case 1:
              pivot.pivotObj.dataSourceSettings.showGrandTotals = false;
              pivot.pivotObj.dataSourceSettings.showRowGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnGrandTotals = true;
              this.config.showGrandTotals = false;
              this.config.showRowGrandTotals = true;
              this.config.showColumnGrandTotals = true;
              break;
            case 2:
              pivot.pivotObj.dataSourceSettings.showGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showColumnGrandTotals = false;
              this.config.showGrandTotals = true;
              this.config.showRowGrandTotals = true;
              this.config.showColumnGrandTotals = false;
              break;
            case 3:
              pivot.pivotObj.dataSourceSettings.showGrandTotals = true;
              pivot.pivotObj.dataSourceSettings.showRowGrandTotals = false;
              pivot.pivotObj.dataSourceSettings.showColumnGrandTotals = true;
              this.config.showGrandTotals = true;
              this.config.showRowGrandTotals = false;
              this.config.showColumnGrandTotals = true;
              break;
            default:
              break;
          }
        }
      }
      if (pivot.pivotObj) {
        pivot.pivotObj.render();
        item.config = CircularJSON.stringify(this.config);
        const portletIndex = this.portlets.findIndex(
          (x) => x.newId === item.newId
        );
        this.portlets[portletIndex] = item;
        this.dashboardService.changePivot.next(item.newId);
      }
    } else {
      const table = find(
        (this.table as any)._results,
        (el) => el.portlet.newId === item.newId
      );
      this.showTableGrandTotalGroup = false;
      this.tableGrandTotalList.forEach((grandtotal) => {
        grandtotal.selected = false;
      });
      this.tableGrandTotalList[index].selected = true;
      if (table) {
        switch (index) {
          case 0:
            this.config.showGrandTotals = true;
            table.grid.element
              .querySelector(".e-gridfooter")
              .classList.remove("hidesummary");
            break;
          case 1:
            this.config.showGrandTotals = false;
            table.grid.element
              .querySelector(".e-gridfooter")
              .classList.add("hidesummary");
            break;
        }
        item.config = CircularJSON.stringify(this.config);
        const portletIndex = this.portlets.findIndex(
          (x) => x.newId === item.newId
        );
        this.portlets[portletIndex] = item;
      }
    }
  }

  getSelectTotalGroupStatus(type?) {
    if (type === "sub") {
      if (
        this.config.showSubTotals &&
        this.config.showRowSubTotals &&
        this.config.showColumnSubTotals
      ) {
        this.pivotTableSubTotalList[0].selected = true;
      }
      if (
        !this.config.showSubTotals &&
        this.config.showRowSubTotals &&
        this.config.showColumnSubTotals
      ) {
        this.pivotTableSubTotalList[1].selected = true;
      }
      if (
        this.config.showSubTotals &&
        this.config.showRowSubTotals &&
        !this.config.showColumnSubTotals
      ) {
        this.pivotTableSubTotalList[2].selected = true;
      }
      if (
        this.config.showSubTotals &&
        !this.config.showRowSubTotals &&
        this.config.showColumnSubTotals
      ) {
        this.pivotTableSubTotalList[3].selected = true;
      }
    } else if (type === "tableGrand") {
      if (this.config && this.config.showGrandTotals) {
        this.tableGrandTotalList[0].selected = true;
      }
      if (!this.config.showGrandTotals) {
        this.tableGrandTotalList[1].selected = true;
      }
    } else {
      if (
        this.config.showGrandTotals &&
        this.config.showRowGrandTotals &&
        this.config.showColumnGrandTotals
      ) {
        this.pivotTableGrandTotalList[0].selected = true;
      }
      if (
        !this.config.showGrandTotals &&
        this.config.showRowGrandTotals &&
        this.config.showColumnGrandTotals
      ) {
        this.pivotTableGrandTotalList[1].selected = true;
      }
      if (
        this.config.showGrandTotals &&
        this.config.showRowGrandTotals &&
        !this.config.showColumnGrandTotals
      ) {
        this.pivotTableGrandTotalList[2].selected = true;
      }
      if (
        this.config.showGrandTotals &&
        !this.config.showRowGrandTotals &&
        this.config.showColumnGrandTotals
      ) {
        this.pivotTableGrandTotalList[3].selected = true;
      }
    }
  }

  initCharData(noDetect = false) {
    if (!this.dashboard) {
      return;
    }
    let filesObj = {}; // 用来翻译
    for (var i in this.DashboardPorletsService.fieldsArr[this.dashboard.id]) {
      if (this.DashboardPorletsService.fieldsArr[this.dashboard.id][i]) {
        this.DashboardPorletsService.fieldsArr[this.dashboard.id][i].forEach(
          (t) => {
            filesObj[t.colName] = t["langCode"];
          }
        );
      }
    }
    this.portlets.forEach((e) => {
      if (!e.config) {
        return;
      }
      const config = JSON.parse(e.config);
      // 如果是 historicalIRR，根据 visualType 进行渲染
      const portletType =
        config.portletType === "historicalIRR"
          ? config.selectedVisualType
          : config.portletType;
      let isNewChart = ["newcolumn", "newline", "newcolumnline"].includes(
        portletType
      );

      if (isNewChart) {
        let dataColumn = [];
        let dataLine = [];
        let yXias = [];
        let secondYXias = [];
        // const config = JSON.parse(e.config);
        if (config.selectedY && config.selectedY.length > 0) {
          yXias = config.selectedY;
        }

        if (config.selectedSecondY && config.selectedSecondY.length > 0) {
          secondYXias = config.selectedSecondY;
        }

        let dataItem;
        if (e.id && e.id != "00000000-0000-0000-0000-000000000000") {
          dataItem =
            this.DashboardPorletsService.portletData_New[this.dashboard.id][
              e.id
            ] || [];
        } else if (e.newId) {
          dataItem =
            this.DashboardPorletsService.portletData_New[this.dashboard.id][
              e.newId
            ] || [];
        }
        if (dataItem && dataItem.data && dataItem.data.length > 0) {
          const xAxisField = config.fields.find(
            (field) => field.colName === config.selectedX
          );
          dataItem.data.forEach((item) => {
            const period =
              xAxisField && xAxisField.dataType === "date"
                ? this.datePipe.transform(item[config.selectedX], "yyyy-MM-dd")
                : item[config.selectedX];
            if (portletType == "newline") {
              if (yXias.length > 0) {
                let obj = { period };
                yXias.forEach((y) => {
                  obj[this.translation[filesObj[y]] || y] = item[y];
                });
                dataLine.push(obj);
              }
            } else {
              if (yXias.length > 0) {
                let obj = { period };
                yXias.forEach((y) => {
                  obj[this.translation[filesObj[y]] || y] = item[y];
                });
                dataColumn.push(obj);
              }

              if (secondYXias.length > 0) {
                let obj = { period };
                secondYXias.forEach((y) => {
                  obj[this.translation[filesObj[y]] || y] = item[y];
                });
                dataLine.push(obj);
              }
            }
          });
        }

        // 时间排序
        if (config.selectedX == "Date") {
          dataColumn && dataColumn.sort(this.compareDates);
          dataLine && dataLine.sort(this.compareDates);
        }

        // 赋值dataColumn和dataLine对应的Type
        config.fields.forEach((t) => {
          if (config.selectedY && config.selectedY.length > 0) {
            if (t["colName"] == config.selectedY[0]) {
              e["columnType"] = t["dataType"];
            }
          }

          if (config.selectedSecondY && config.selectedSecondY.length > 0) {
            if (t["colName"] == config.selectedSecondY[0]) {
              e["lineType"] = t["dataType"];
            }
          }
        });

        e["dataColumn"] = dataColumn;
        e["dataLine"] = dataLine;
        if (config["selectTheme"]) {
          e["themeColor"] = this.themeObj[config["selectTheme"]];
        }
      }
    });
    if (!noDetect) {
      this.setActiveDashboardPortlets();
    }
  }

  compareDates(a, b) {
    const dateA = new Date(a.period);
    const dateB = new Date(b.period);

    if (dateA < dateB) {
      return -1;
    } else if (dateA > dateB) {
      return 1;
    } else {
      return 0;
    }
  }

  truncateText(text, maxWidth = 70, fontSize = 11) {
    // 创建一个隐形的 span 来测量文本宽度
    const measureSpan = document.createElement("div");
    measureSpan.style.visibility = "hidden";
    measureSpan.style.position = "absolute";
    measureSpan.style.fontSize = fontSize + "px";
    measureSpan.style.whiteSpace = "nowrap";
    measureSpan.innerText = text;
    document.body.appendChild(measureSpan);

    // 二分查找来找到最佳截断点
    let left = 1;
    let right = text.length - 1;
    let leftOrRight = "left";
    let isBigger = false;
    if (measureSpan.offsetWidth > maxWidth) {
      while (!isBigger) {
        measureSpan.innerText = `${text.slice(0, left)}...${text.slice(right)}`;
        if (measureSpan.offsetWidth > maxWidth) {
          isBigger = true;
        } else {
          if (leftOrRight === "left") {
            leftOrRight = "right";
            left = left + 1;
          } else {
            leftOrRight = "left";
            right = right - 1;
          }
        }
      }
    } else {
      document.body.removeChild(measureSpan);
      return text;
    }
    // 清理并返回结果
    document.body.removeChild(measureSpan);
    return `${text.slice(0, left - 1)}${left !== 1 ? "..." : ""}${text.slice(
      right + 1
    )}`;
  }

  getPaddingBottom() {
    let paddingBotto = 50;
    // 存在Title 或者 Description占位置时
    if (
      this.dashboard &&
      (this.dashboard.title || this.dashboard.description)
    ) {
      let gap = 0;
      if (this.dashboard.title) {
        gap += 5;
      }
      if (this.dashboard.description) {
        gap += 20;
      }
      const element: any = document.querySelector(".portlets-description");
      paddingBotto = element ? element.offsetHeight + gap + 50 : 50;
    }
    return paddingBotto + "px";
  }

  updateDashboardLastUpdateDate() {
    this.pbf.pageLoading = true;
    this.pbf.pageLoading_.next(true);
    const _dataObj = { dashboardId: this.url_id, language: this.lang };
    this.http.post(this.api.urlList.GetDashboardV2, _dataObj, (res) => {
      res = this.pbf.convertKeysToLowerCase(res);
      this.dashboard.UpdatedDate = res.UpdatedDate;
      this.pbf.pageLoading = false;
      this.pbf.pageLoading_.next(true);
    });
  }

  savedashboard(shouldUpdate = "false") {
    this.pbf.pageLoading = true;
    this.pbf.pageLoading_.next(true);
    const pdata = this.dashboardLayout.serialize();
    this.newPosition = [...pdata];
    const portlets = [...this.portlets];

    if (portlets && portlets.length) {
      let activeTabHasPortlet = false;
      const tabIds = [];
      portlets.map((el) => {
        const data = find(this.newPosition, (item) => item.id === el.newId);
        if (data) {
          el.col = data.col;
          el.posX = data.col;
          el.row = data.row;
          el.posY = data.row;
          el.sizeX = data.sizeX;
          el.width = data.sizeX;
          el.sizeY = data.sizeY;
          el.height = data.sizeY;
        }
        let config = el.config ? JSON.parse(el.config) : null;
        if (config) {
          config = {
            ...config,
            prevDashboarId: el.id,
            activeTab: this.activeTab,
          };
          tabIds.push(config.tabId);
          if (config.tabId === this.activeTab) {
            activeTabHasPortlet = true;
          }
          el.config = CircularJSON.stringify(config);
        }
      });
      if (!activeTabHasPortlet) {
        portlets.forEach((el) => {
          let config = el.config ? JSON.parse(el.config) : null;
          if (config) {
            config = {
              ...config,
              prevDashboarId: el.id,
              activeTab: tabIds[0],
            };
          }
          el.config = CircularJSON.stringify(config);
        });
      }
    }
    let dataObj = {
      portlets,
      dashboardId: this.url_id,
      lastUpdateDate: this.dashboard.UpdatedDate,
    };
    this.http.post(this.api.urlList.SaveDashboardPortlets, dataObj, (res) => {
      if (res.status == "SUCCESS") {
        this.DashboardPorletsService.GetDashboardV1(
          this.url_id,
          false,
          (_res, _portlets = []) => {
            this.pbf.pageLoading = false;
            this.pbf.pageLoading_.next(true);
            if (!_res) {
              return;
            }
            const _saveMessage =
              this.translation.DASHBOARD_SAVE_MESSAGE ||
              "Dashboard has been updated";
            this.dialogService.showSucMsg(_saveMessage);
            if (shouldUpdate !== "true") {
              this.toggleCustomize(false);
              this.toggleSidebar(false);
              this.updatePushBtn(false);
            }
            this.updateDashboard({
              dashboard: _res,
              portlets: _portlets,
              noDetect: true,
            });
            this.initlayout(true);
            this.ref.markForCheck();
            this.ref.detectChanges();
          }
        );
      } else {
        let errorMessage = "Dashboard save failed";
        if (Array.isArray(res.messages)) {
          errorMessage = res.messages[0].message;
        }
        this.dialogService.showNotification(errorMessage, {
          status: "Error",
        });
        this.pbf.pageLoading = false;
        this.pbf.pageLoading_.next(true);
      }
    });
  }
}
